export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'ca240469-5555-473d-b1bd-563b53ae575f';
export const MODEL_CLOSE_SEC = 2.5;